<template>
    <label class="input__wrapper">
        <input
            v-bind="attrs"
            ref="input"
            class="input__field"
            :class="{'error' : props.hasError, 'has-icon': props.hasError || props.ticker}"
            :value="props.modelValue"
            type="text"
            :readonly="props.readOnly"
            :disabled="props.disabled"
            :maxlength="props.maxLength"
            :placeholder="props.placeholder"
            @input="onInput"
            @focus="emit('focus')"
            @blur="emit('blur')"
        >

        <HintIcon
            v-if="props.hasError"
            role="alert"
            aria-label="alert"
            class="input__icon input__icon-error"
            icon="alert"
            :text="props.errorMsg"
        />

        <span
            v-if="props.ticker"
            v-show="!props.hasError"
            class="input__ticker"
            aria-label="input-ticker"
        >
            <span>{{ props.ticker }}</span>
        </span>
    </label>
</template>

<script>
export default {
    name: 'BaseInput',
    inheritAttrs: false,
};
</script>

<script setup>
import { inject, onMounted, ref, useAttrs } from 'vue';
import HintIcon from '@/components/ui/HintIcon/index.vue';

const attrs = useAttrs();
const isHSm = inject('isHSm');
const emit = defineEmits(['update:modelValue', 'focus', 'blur']);
const input = ref(null);

const props = defineProps({
    modelValue: { type: [String, Number, null], required: true, default: '' },
    inputNumber: { type: Boolean },
    integerNumber: { type: Boolean },
    placeholder: { type: String, default: '' },
    maxLength: { type: Number, default: 255 },
    hasError: { type: Boolean },
    errorMsg: { type: String, default: 'Wrong input!' },
    ticker: { type: String, default: '' },
    focusOnMounted: { type: Boolean },
    disabled: { type: Boolean },
    readOnly: { type: Boolean },
});

const onInput = ev => {
    const { value } = ev.target;
    if (!props.inputNumber) return emit('update:modelValue', ev.target.value.trim());

    let newValue = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    if (props.integerNumber) {
        newValue = value.replace(/[^0-9]/g, '');
    }
    if (newValue.startsWith('.')) {
        newValue = '0' + newValue;
    }
    ev.target.value = newValue;
    emit('update:modelValue', Number(newValue));

    clearTimeout(ev.target.timer);
    ev.target.timer = setTimeout(() => {
        if (newValue.endsWith('.')) {
            newValue = newValue.slice(0, -1);
            ev.target.value = newValue;
            emit('update:modelValue', Number(newValue));
        }
    }, 3000);
};

onMounted(async () => {
    if (props.focusOnMounted && typeof input.value?.focus === 'function' && !isHSm?.value) {
        input.value?.focus();
    }
});
</script>
